import { render, staticRenderFns } from "./BasicDataTab.vue?vue&type=template&id=de1f5462&scoped=true&"
import script from "./BasicDataTab.vue?vue&type=script&lang=js&"
export * from "./BasicDataTab.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataTab.vue?vue&type=style&index=0&id=de1f5462&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1f5462",
  null
  
)

component.options.__file = "BasicDataTab.vue"
export default component.exports